export enum VideoPlatform {
    vimeo = 'vimeo',
    youtube = 'youtube',
}
